import React from 'react';
import PropTypes from 'prop-types';

class ValidationMessage extends React.Component {
    render() {
        if (this.props.visible) {
            return <div className="validation-message">{this.props.text}</div>;
        } else {
            return <div />;
        }
    }
}

ValidationMessage.propTypes = {
    text: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired
};

export default ValidationMessage;
